'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _bluebird = require('bluebird');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_bluebird.Promise.config({
  cancellation: true
});

var ApiClient = function () {
  function ApiClient(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient);

    ['get', 'post', 'put', 'patch', 'del'].forEach(function (method) {
      _this[method] = function (path, options) {
        return new _bluebird.Promise(function (resolve, reject, onCancel) {
          var request = _superagent2.default[method](_this.formatUrl(path));

          if (__SERVER__ && req.get('cookie')) {
            request.set('cookie', req.get('cookie'));
          }

          if (options && options.data) {
            request.send(options.data);
          }
          if (options && options.image) {
            request.attach('image', options.image, options.image.name);
          }
          if (options && options.params) {
            request.query(options.params);
          }

          request.set('x-requested-with', 'XMLHttpRequest').end(function (err, res) {
            if (err && res) {
              reject(res.body || err);
            } else if (err) {
              reject(err);
            } else {
              resolve(res.body);
            }
          });

          onCancel(function () {
            request.abort();
          });

          return request;
        });
      };
    });
  }

  /* This was originally a standalone function outside of this class, but babel kept breaking, and this fixes it  */


  (0, _createClass3.default)(ApiClient, [{
    key: 'formatUrl',
    value: function formatUrl(path) {
      var adjustedPath = path[0] !== '/' ? '/' + path : path;
      if (__SERVER__) {
        // Prepend host and port of the API server to the path.
        return 'http://localhost:' + _config2.default.port + '/api' + adjustedPath;
      }
      // Prepend `/api` to relative URL, to proxy to API server.
      return '/api' + adjustedPath;
    }
  }]);
  return ApiClient;
}();

exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 2276
// module chunks = 0